module.exports = __webpack_public_path__ + "img/459-4594463_24-7-365-png-transparent-png-recovered.65b034f3.png";